import {atom} from 'recoil';

import {IServiceRequestImports} from '../../shared/types/serviceRequestImport.types';
import {IAddressItemSelectOption} from '../../api/strategies/searchAddressItemStrategy';
import {IPageableDto, IPageableTable} from '../../shared/types/pageable.types';

const EMPTY_PAGE_IMPORT = {
  totalPages: 0,
  totalElements: 0,
  pageable: {
    paged: false,
    unpaged: false,
    pageNumber: 0,
    pageSize: 0,
    offset: 0,
    sort: {},
  },
  numberOfElements: 0,
  size: 0,
  content: [],
  number: 0,
  sort: {},
  first: false,
  last: false,
  empty: false,
};

export const serviceRequestImportsState = atom<IPageableDto<IServiceRequestImports>>({
  key: 'serviceRequestImportsState',
  default: JSON.parse(JSON.stringify(EMPTY_PAGE_IMPORT)),
});

export const serviceRequestImportsOfContractState = atom<IPageableDto<IServiceRequestImports>>({
  key: 'serviceRequestImportsOfContractState',
  default: JSON.parse(JSON.stringify(EMPTY_PAGE_IMPORT)),
});

export const currentServiceRequestImportsState = atom<IServiceRequestImports | null>({
  key: 'currentServiceRequestImportsState',
  default: null,
});

export const serviceRequestImportsQueryTrigger = atom<number>({
  key: 'serviceRequestImportsQueryTrigger',
  default: 0,
});

export const importOfDevicesQueryTrigger = atom<number>({
  key: 'importOfDevicesQueryTrigger',
  default: 0,
});

export const openedImportRowsState = atom<string[]>({
  key: 'openedImportRowsState',
  default: [],
});

export const recentlySearchedRegions = atom<IAddressItemSelectOption[]>({
  key: 'recentlySearchedRegions',
  default: [],
});

export const importOfDevicesState = atom<IPageableDto<IServiceRequestImports>>({
  key: 'importOfDevicesState',
  default: JSON.parse(JSON.stringify(EMPTY_PAGE_IMPORT)),
});

export const importPageable = atom<IPageableTable>({
  key: 'importPageable',
  default: {
    page: 0,
    size: localStorage.getItem('importsPerPage') ? parseInt(localStorage.getItem('importsPerPage') as string, 10) : 20,
  },
});

export const importOfDevicesPageable = atom<IPageableTable>({
  key: 'importOfDevicesPageable',
  default: {
    page: 0,
    size: localStorage.getItem('importOfDevicesPerPage')
      ? parseInt(localStorage.getItem('importOfDevicesPerPage') as string, 10)
      : 20,
  },
});
